
const AppContext = {
    currentPromotion: "80%",
    currentPromotionNumber: 80,
    ctaWidgetPromotion: "",
    modalCtaPopup: ""
};

export default AppContext;